import { useEffect, useState } from 'react';

export const useExhibitCategoryCheck = ({
  allListCount,
  selectedCount,
  onSelectAllExhibit,
  exhibitCategoryTabType,
}) => {
  const [allChecked, setAllChecked] = useState(false);
  const [indeterminate, setIndeterminate] = useState(false);

  const onCheckAll = (checked) => {
    setIndeterminate(false);
    onSelectAllExhibit(checked);
    setAllChecked((prev) => !prev);
  };

  //체크가 되어있고, 전체 체크가 아닌 상태는 전체체크박스에 표시가 되어야함
  useEffect(() => {
    if (!selectedCount) {
      setIndeterminate(false);
      setAllChecked(false);
      return;
    }

    if (selectedCount < allListCount) {
      setIndeterminate(true);
    }
  }, [selectedCount, allListCount]);

  //탭이 전환되면 전체 체크상태 리셋
  useEffect(() => {
    setAllChecked(false);
  }, [exhibitCategoryTabType]);

  return { allChecked, indeterminate, onCheckAll };
};
